import { type ReactNode } from "react";
import { createPortal } from "react-dom";

type TeleportTarget = string | Element | null | undefined;

export type VueTeleportProps = {
  children?: ReactNode;
  to?: TeleportTarget;
  disabled?: boolean;
};

function resolveTarget(to?: TeleportTarget): Element | null {
  if (!to) return null;
  if (typeof to === "string") return document.querySelector(to);
  return to;
}

export function VueTeleport({ children, to = "body", disabled = false }: VueTeleportProps): ReactNode {
  if (disabled) return children;
  const target = resolveTarget(to);
  if (!target) return children;
  return createPortal(children, target);
}
